
import render from '../../../plugins/vessel/methods/render'
import svgTag from './svg'

export default {
  name: 'VsIcon',
  functional: true,
  props: {
    name: {
      type: String,
      default: null
    },
    position: {
      type: String,
      default: null
    },
    tag: {
      type: String,
      default: 'i'
    },
    ...svgTag.props
  },
  render(h, { data, props }) {
    const tag = props.path ? [h(svgTag, { props })] : []
    const cls = ['el-icon-uil', 'vs-icon']

    if (props.name)
      cls.push('uil', `uil-${props.name}`)

    if (props.path)
      cls.push('vs-icon-svg')

    if (props.position)
      cls.push(`el-icon--${props.position}`)

    if (data.class)
      cls.push(...Object.keys(data.class))

    return render(h, props.tag, { ...data, class: cls, props: props }, tag)
  }
}
